import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: uuid(),
    categoryName: "notion",
  },
  {
    _id: uuid(),
    categoryName: "obsidian",
  },
  {
    _id: uuid(),
    categoryName: "logSeq",
  },
  {
    _id: uuid(),
    categoryName: "techniques",
  },
];
